module.exports = __webpack_public_path__ + "static/media/cases_anuncios_02d.4a0330c2.jpg";